var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['btn', _vm.model, _vm.size, _vm.group, _vm.stateClass],style:({margin: _vm.margin}),on:{"click":_vm.toggle}},[(!_vm.dualActive)?_vm._t("defaultPre"):_vm._e(),(_vm.dualActive)?_vm._t("activePre"):_vm._e(),_vm._v(" "+_vm._s(_vm.value)+" "),(!_vm.dualActive)?_vm._t("default"):_vm._e(),(_vm.dualActive)?_vm._t("active"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }